export default "__VITE_ASSET__lp6IX1TmDRPCjjOrcY3lkg__"